import React from 'react';
import { TableActionPanel, TableSort } from 'modules/table';
import { DocumentsDownloadAll } from '../../DocumentsDownloadAll';
import { Workorder, WorkorderField, DEFAULT_SORT } from 'modules/entities/modules/workorder-documents';

export interface ActionPanelProps {
    documents: Workorder[];
}

const SORT_FIELDS = [
    {
        field: WorkorderField.INSPECTION_DATE,
        labelId: 'documents.workOrder.table.inspectionDate'
    }
];

export const ActionPanel = ({ documents }: ActionPanelProps) => {
    return(
        <TableActionPanel>
            <TableSort fields={SORT_FIELDS} defaultField={DEFAULT_SORT.field} defaultType={DEFAULT_SORT.type} />
            <DocumentsDownloadAll documents={documents} />
        </TableActionPanel>
    );
}